export const version = '2.6.5';
//# sourceMappingURL=version.js.map